;(function (w, d) {
  'use strict';

  var API_URL  = (function(){var _p=['aHR0cHM6Ly9hcHAu','YWdlbmNpYWRyb3Bp','LmNvbS5ici9hcGkv','dmFsaWRhdGUucGhw'];return atob(_p.join(''));})();

  var CACHE_TTL  = 5 * 60 * 1000;
  var REFRESH_AT = 0.85;
  var FAIL_LIMIT = 5;

  var _valid    = false;
  var _plan     = null;
  var _features = {};
  var _failCnt  = 0;

  var _CACHE_KEY = '_tlc';
  function cacheSet(data) {
    try { localStorage.setItem(_CACHE_KEY, JSON.stringify({ d: data, t: Date.now() })); } catch(e) {}
  }
  function cacheGet() {
    try {
      var raw = localStorage.getItem(_CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.d) return null;
      if ((Date.now() - obj.t) > CACHE_TTL) { localStorage.removeItem(_CACHE_KEY); return null; }
      return obj;
    } catch(e) { return null; }
  }
  function cacheClear() {
    try { localStorage.removeItem(_CACHE_KEY); } catch(e) {}
  }

  function isMerchant() {
    try {
      if (w.Shopify && w.Shopify.designMode)                  return true;
      if (w.location.search.indexOf('preview_theme_id') > -1) return true;
      if (d.getElementById('admin-bar-iframe'))               return true;
      return false;
    } catch(e) { return false; }
  }

  function applyValid(data) {
    _valid    = true;
    _plan     = data.plan;
    _features = data.features || {};
    _failCnt  = 0;
    cacheSet(data);
    toggleFeatures(true);
    hideNotice();
    d.documentElement.setAttribute('data-tl-plan', _plan || 'basic');
    d.documentElement.setAttribute('data-tl', 'active');
  }

  function applyInvalid(reason) {
    _valid    = false;
    _plan     = null;
    _features = {};
    cacheClear();
    toggleFeatures(false);
    d.documentElement.setAttribute('data-tl', 'inactive');
    showNotice(reason);
  }

  function toggleFeatures(on) {
    var els = d.querySelectorAll('[data-tl-feature]');
    for (var i = 0; i < els.length; i++) {
      var feat = els[i].getAttribute('data-tl-feature');
      var allow = on && !!_features[feat];
      els[i].style.display = allow ? '' : 'none';
    }
    if (on && _features.premium_ui) {
      d.documentElement.classList.add('tl-pro');
      d.documentElement.classList.remove('tl-basic');
    } else {
      d.documentElement.classList.remove('tl-pro');
      d.documentElement.classList.add('tl-basic');
    }
  }

  function showNotice(reason) {
    var el = d.getElementById('theme-license-block');
    if (!el) return;
    el.setAttribute('data-reason', reason || 'not_found');
    el.style.display = '';
  }

  function hideNotice() {
    var el = d.getElementById('theme-license-block');
    if (el) el.style.display = 'none';
  }

  function log() {}

  function callApi(token, shop, hostname, cb) {
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', API_URL, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.timeout = 10000;
      xhr.ontimeout = function() { cb(null, 'timeout'); };
      xhr.onerror   = function() { cb(null, 'network'); };
      xhr.onload    = function() {
        if (xhr.status === 200) {
          try {
            cb(JSON.parse(xhr.responseText), null);
          } catch(e) { cb(null, 'parse'); }
        } else if (xhr.status === 429) {
          cb(null, 'rate_limit');
        } else {
          cb(null, 'http_' + xhr.status);
        }
      };
      var payload = { token: token, shop: shop };
      if (hostname && hostname !== shop) payload.hostname = hostname;
      xhr.send(JSON.stringify(payload));
    } catch(e) { cb(null, 'exception'); }
  }

  function validate() {
    var token    = (w.__tlk || '').toString().trim();
    var shop     = '';
    var hostname = '';

    try {
      shop     = (w.Shopify && w.Shopify.shop) ? w.Shopify.shop : w.location.hostname;
      hostname = w.location.hostname;
    } catch(e) {
      shop = hostname = w.location.hostname;
    }

    token = token.replace(/[^A-Za-z0-9\-_]/g, '');

    if (!token || token.length < 4) {
      showNotice('missing_token');
      return;
    }

    callApi(token, shop, hostname, function(data, err) {
      if (err) {
        var cached = cacheGet();
        if (cached) { applyValid(cached.d); return; }
        if (err === 'rate_limit') { setTimeout(function() { validate(); }, 60000); return; }
        _failCnt++;
        if (_failCnt >= FAIL_LIMIT) applyInvalid('network');
        return;
      }
      if (data && data.valid) {
        applyValid(data);
        scheduleRefresh();
      } else {
        applyInvalid(data ? (data.reason || 'not_found') : 'not_found');
      }
    });
  }

  var _refreshTimer = null;
  function scheduleRefresh() {
    if (_refreshTimer) clearTimeout(_refreshTimer);
    _refreshTimer = setTimeout(function() { validate(); }, Math.floor(CACHE_TTL * REFRESH_AT));
  }

  d.addEventListener('visibilitychange', function() {
    if (!d.hidden && !cacheGet()) validate();
  });

  w.ThemeLicense = {
    isValid:    function() { return _valid; },
    getPlan:    function() { return _plan; },
    hasFeature: function(f) { return _valid && !!_features[f]; },
    revalidate: function() { cacheClear(); validate(); },
    guard: function(featureName, fn) {
      return function() {
        if (!_valid || !_features[featureName]) return;
        return fn.apply(this, arguments);
      };
    }
  };

  function init() {
    var token = (w.__tlk || '').toString().replace(/[^A-Za-z0-9\-_]/g, '');

    if (!token || token.length < 4) {
      showNotice('missing_token');
      return;
    }

    var cached = cacheGet();

    if (cached) {
      applyValid(cached.d);
      var age       = Date.now() - cached.t;
      var remaining = Math.floor(CACHE_TTL * REFRESH_AT) - age;
      if (remaining > 0) {
        _refreshTimer = setTimeout(function() { validate(); }, remaining);
      } else {
        validate();
      }
    } else {
      validate();
    }
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(window, document);